import serviceBg1 from '../../assets/images/why-bg.png';
import serviceBg2 from '../../assets/images/why-bg-2.png';
import serviceBg3 from '../../assets/images/why-bg-3.png';
import serviceBg4 from '../../assets/images/why-bg-4.png';

const cardData = [
  {
    title: 'Earn on your terms',
    description:
      "With Speedyssey, you choose when and how much you work. Deliver part-time or full-time, it’s up to you.",
    bg: serviceBg1,
  },
  {
    title: 'Easy-to-use app',
    description:
      'Our delivery partner app is built for speed and simplicity. Accept orders, navigate, and track earnings, all in one place.',
    bg: serviceBg2,
  },
  {
    title: 'Fast onboarding',
    description:
      'Get started quickly with a smooth registration and verification process. No lengthy delays, no complicated steps.',
    bg: serviceBg3,
  },
  {
    title: 'Reliable support',
    description:
      'From live order issues to account help, our dedicated support team is always here for you.',
    bg: serviceBg4,
  },
];

function WhyDeliver() {
  return (
    <section className="container mx-auto px-6 lg:px-12 py-16 lg:py-24 space-y-12">
      {/* Heading */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start justify-between">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight max-w-lg">
          Why Deliver with
          <br />Speedyssey?
        </h2>
        <p className="text-gray-700 text-lg md:text-xl max-w-lg md:justify-self-end">
          Earn on your terms with Speedyssey. Join thousands already delivering and making flexible daily income.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {cardData.map(({ title, description, bg }) => (
          <div
            key={title}
            className="rounded-2xl p-8 lg:p-10 h-[250px] space-y-4 text-white"
            style={{
              backgroundImage: `url(${bg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <h3 className="text-[#F55109] pt-16 text-xl md:text-2xl font-semibold">
              {title}
            </h3>
            <p className="text-gray-200 leading-relaxed text-base md:text-lg">
              {description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhyDeliver;
